import {
    FetchPostPayLoad,
    FetchPostResponse,
    IInstagramRepository,
    InstagramResult,
} from '@lib/domain/instagram/interface';
import { SearchInstagramInputSchema } from '@lib/domain/instagram/schema';

import { HTTPService } from '@lib/infra/HTTPService/HTTPService';

interface Dependencies {
    httpService: HTTPService;
}

export class InstagramRepository implements IInstagramRepository {
    private httpService: HTTPService;

    constructor({ httpService }: Dependencies) {
        this.httpService = httpService;
    }

    async getUserInfo(
        payload: SearchInstagramInputSchema,
    ): Promise<InstagramResult> {
        const res = await this.httpService.get({
            url: 'instagram/users',
            data: payload,
            options: { timeout: 120000 },
            isHmac: true,
        });

        const { data } = res;

        return data;
    }
    async getPost(payload: FetchPostPayLoad): Promise<FetchPostResponse> {
        const res = await this.httpService.get({
            url: 'instagram/posts',
            data: payload,
            options: { timeout: 120000 },
            isHmac: true,
        });
        const { data } = res;
        return data;
    }
}
